export default "__VITE_ASSET__a8cbe4e1__"